import React, { memo, useCallback, useState } from 'react';
import { Col, Input, Modal, Row } from 'antd';
import { useQuery } from 'react-query';

import DF from '../../DisplayFramework';
import {
  ParMarketingResponse,
  getAssetCatalogOrAssetPackByKeyword,
} from '../../services/assetconfig';
import useDebounce from '../../hooks/useDebounce';
import GetLabel from 'DisplayFramework/components/GetLabel';
import AssetCatalogPackItem from './AssetCatalogPackItem';

export type AssetCatalogPackModalProps = {
  visible: boolean;
  onCancel: () => void;
  onSelect: (
    item: ParMarketingResponse,
    nbasset: number,
   ) => void;
  currcode?: string;
  flagwebshop?: boolean;
};

const AssetCatalogPackModal = (props: AssetCatalogPackModalProps) => {
  const { visible, onCancel, onSelect, currcode, flagwebshop } = props;

  const [assetkeyword, setAssetkeyword] = useState('');

  const debouncedAssetKeyword = useDebounce(assetkeyword);

  const { data: assetsCatalog } = useQuery(
    ['getAssetCatalogOrAssetPackByKeyword', { debouncedAssetKeyword }],
    () =>
    getAssetCatalogOrAssetPackByKeyword({
        keyword: debouncedAssetKeyword,
        filters: '',
        mcid: '',
        mgid: '',
        networkcode: '',
        tpidbroker: '',
        currcode: currcode,
        flagwebshop: flagwebshop ?? false,
      } as any).then((res) => res.list || []),
    {
      enabled: debouncedAssetKeyword.length > 2,
      staleTime: 30 * 1000,
    }
  );

  const clearAndCancel = useCallback(() => {
    setAssetkeyword('');
    onCancel();
  }, [onCancel, setAssetkeyword]);

  const handleSelect = useCallback(
    (item, nbasset) => {
      setAssetkeyword('');
      onSelect(item, nbasset);
    },
    [onSelect]
  );

  return (
    <Modal
      visible={visible}
      title={<GetLabel label="assetcatalog" Inspectstyle={{ width: '30%' }} />}
      footer={null}
      onCancel={clearAndCancel}
      width={1200}
    >
      <DF.Input comcode="assetkeyword">
        <Input
          onChange={(event) => setAssetkeyword(event.target.value)}
          value={assetkeyword}
        />
      </DF.Input>

      <Row gutter={10}>
        {assetsCatalog?.map((item, index) => (
          <Col key={index} lg={8} style={{ marginBottom: 10 }}>
            <AssetCatalogPackItem item={item} onSelect={handleSelect} />
          </Col>
        ))}
      </Row>
    </Modal>
  );
};

export default memo(AssetCatalogPackModal);
